import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledAddProductModal = styled(Modal)`
  .ant-input-number-group-wrapper {
    width: 100%;

    .ant-input-number {
      border: 2px solid ${(props) => props.theme.borderTable};
      border-radius: 5px 0 0 5px;
      border-right: none;
    }

    .ant-input-number-group-addon {
      border: 2px solid ${(props) => props.theme.borderTable};
      border-radius: 0 5px 5px 0;
    }
  }

  .ant-input-number:not(.ant-input-number-in-form-item) {
    width: 100%;
    border: 2px solid ${(props) => props.theme.borderTable};
    border-radius: 5px;
  }
`;
